// Frontend mirror of backend product-type catalog.
// Should match backend/product_types.py keys.
export const PRODUCT_TYPES = [
    // Clothing
    { value: "saree", label: "Saree", is_jewellery: false },
    { value: "shirt_men", label: "Men's Shirt", is_jewellery: false },
    { value: "tshirt_women", label: "Women's Top / T-shirt", is_jewellery: false },
    { value: "jeans", label: "Jeans / Trousers", is_jewellery: false },
    { value: "dress", label: "Dress / Gown", is_jewellery: false },
    { value: "kurti", label: "Kurti / Salwar / Lehenga", is_jewellery: false },
    { value: "kids_boys", label: "Kids wear (Boys)", is_jewellery: false },
    { value: "kids_girls", label: "Kids wear (Girls)", is_jewellery: false },
    { value: "footwear", label: "Footwear", is_jewellery: false },
    { value: "bag", label: "Bag / Accessory", is_jewellery: false },
    // Jewellery (sub-types)
    { value: "necklace", label: "Necklace / Haram / Mangalsutra", is_jewellery: true, body_region: "neck" },
    { value: "earrings", label: "Earrings / Jhumkas / Studs", is_jewellery: true, body_region: "ears" },
    { value: "bangles", label: "Bangles / Bracelets / Kada", is_jewellery: true, body_region: "wrist" },
    { value: "rings", label: "Rings", is_jewellery: true, body_region: "finger" },
    { value: "nose_pin", label: "Nose Pin / Maang Tikka", is_jewellery: true, body_region: "face" },
    { value: "anklet", label: "Anklet / Vaddanam / Payal", is_jewellery: true, body_region: "ankle" },
    { value: "jewellery", label: "Jewellery (mixed)", is_jewellery: true, body_region: "neck" },
];

export const PRODUCT_TYPE_LABEL = Object.fromEntries(
    PRODUCT_TYPES.map((p) => [p.value, p.label])
);

export const JEWELLERY_TYPES = new Set(
    PRODUCT_TYPES.filter((p) => p.is_jewellery).map((p) => p.value)
);

export function isJewellery(pt) {
    return !!pt && JEWELLERY_TYPES.has(pt);
}

/** True iff at least one of the shop's product types is jewellery. */
export function shopHasJewellery(shop) {
    const types = shop?.default_product_types || (shop?.default_product_type ? [shop.default_product_type] : []);
    return types.some(isJewellery);
}

/**
 * Compute today's price for a jewellery item, given the shop's current rate.
 * Returns null if any required value is missing.
 *   price = rate_per_gram × net_weight_g + making_charges
 *   making_charges = making_charges_inr || (making_charges_pct/100 × rate × net_weight)
 */
export function computeJewelleryPrice(saree, shop) {
    if (!saree || !shop) return null;
    const purity = (saree.purity || "").toUpperCase();
    const net = Number(saree.net_weight_g || 0);
    if (!net) return null;
    let rate = 0;
    if (purity.startsWith("22")) rate = Number(shop.gold_rate_22k || 0);
    else if (purity.startsWith("18")) rate = Number(shop.gold_rate_18k || 0);
    else if (purity === "916") rate = Number(shop.gold_rate_22k || 0);
    else if (purity.startsWith("925") || purity === "SILVER") rate = Number(shop.gold_rate_silver || 0);
    else rate = Number(shop.gold_rate_22k || 0);
    if (!rate) return null;
    const metal = rate * net;
    let making = 0;
    if (saree.making_charges_inr) making = Number(saree.making_charges_inr);
    else if (saree.making_charges_pct) making = (Number(saree.making_charges_pct) / 100) * metal;
    return Math.round(metal + making);
}

export function formatInr(n) {
    if (n == null || isNaN(n)) return "—";
    return "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
}
